import { useEffect, useState } from "react";

// Dark mode is a workspace-wide setting ("working under the lamp at night"),
// so it lives in localStorage rather than the per-page editor store. The store
// mirrors it for toolbar state; chrome outside the store (page header, pages
// sidebar) subscribes through this hook.
const STORAGE_KEY = "striply_dark_mode";
const CHANGE_EVENT = "striply-darkmode-change";

export const getDarkModeSetting = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const setDarkModeSetting = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
  } catch (e) {
    // localStorage unavailable — dark mode just won't persist
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: value }));
};

export const useDarkModeSetting = () => {
  const [darkMode, setDarkMode] = useState(getDarkModeSetting);
  useEffect(() => {
    const handleChange = (e) => setDarkMode(Boolean(e.detail));
    window.addEventListener(CHANGE_EVENT, handleChange);
    return () => window.removeEventListener(CHANGE_EVENT, handleChange);
  }, []);
  return darkMode;
};
